<div *ngIf="reportType == 'briefly1'">
    <div class="container-fluid" id="print-section">
      <div class="table-responsive">
        <table class="table table-bordered table-sm">
            <thead style="background-color: #f1f1f1;"> <!-- Light grey background -->
                <tr>
                  <th colspan="2" style="color: #525f7f; text-align: center;font-size: 14px;">
                    Vivek Saptahik 
                  </th>
                  <th colspan="2" style="color: #525f7f; text-align: center; font-size: 14px;">
                    Advertisement Payment Receipt Ledger
                  </th>
                  <th colspan="1" style="color: #525f7f;">Briefly</th>
                  <th colspan="2" style="color: #525f7f;">
                    From: {{startDate | date: 'dd-MM-yyyy'}} To: {{endDate | date: 'dd-MM-yyyy'}}
                  </th>
                </tr>
             
                <tr>
                  <th style="color: #525f7f;">Receipt <br> No</th>
                  <th style="color: #525f7f;">Receipt <br> Date</th>
                  <th style="color: #525f7f;">Entry <br> Date</th>
                  <th style="color: #525f7f;">Advertiser <br> Name</th>
                  <th style="color: #525f7f;">Representative <br>Name</th>
                  <th style="color: #525f7f;">Office <br> Rep. Name</th>
                  <th class="text-end" style="color: #525f7f;">Received <br>Amount</th>
                </tr>
              </thead>              
          <tbody>
            <tr *ngFor="let data1 of advtBrieflyFormBeans; let i = index">
              <td><strong>{{data1.rcpt_no}}</strong></td>
              <td><strong>{{data1.rcpt_date}}</strong></td>
              <td><strong>{{data1.entry_date}}</strong></td>
              <!-- <td style="weight:0%"><strong>{{data1.advt_name}}</strong></td> -->
               <td style="width: 0%;">
  <strong>{{data1.advt_name | slice : 0:35}}</strong>
</td>

              <td style="width: 0%;"><strong>{{data1.rep_name}}</strong></td>
              <td style="width: 0%;"><strong>{{data1.off_rep_name}}</strong></td>
              <td class="text-end" style="text-align: end;"><strong>{{data1.rcv_amt}}</strong></td>
            </tr>
          </tbody>
          <!-- <tfoot> -->
            <tr>
              <td colspan="6" class="text-end"  style="text-align: center; background-color: #f1f1f1 !important;font-weight:bold;font-size:16px"><strong>Total:</strong></td>
              <td colspan="1" class="text-end" style="text-align: end; background-color: #f1f1f1 !important;font-weight:bold;font-size:15px"><strong>Rs {{(advtBrieflyTotal * 1).toFixed(2)}}</strong></td>
            </tr>
          <!-- </tfoot> -->
        </table>
      </div>
    </div>
  
    <div class="button-container noPrint">
        <button class="modern-btn btn-primary-modern noPrint" 
            (click)="exportExcel('Contract_InDetails_Report')" 
            mat-raised-button color="primary">
        Export
        </button>

        <button class="modern-btn btn-primary-modern noPrint"
            mat-raised-button color="primary"
            (click)="printPageA4()">
          Print
        </button>

        <button class="modern-btn btn-secondary-modern noPrint" 
            mat-button mat-dialog-close>
          Close
        </button>
    </div>
  </div>
  